import { useCallback, cloneElement } from 'react';

import { Box, Flex } from '@chakra-ui/react';

import { Download } from 'assets/assetsV1/iconComponents';
import noDataGraphV1 from 'assets/assetsV1/illustrations/newIllustrations/noDataGraphV1.svg';

import { Button } from 'uiToolkitV1/Button';
import { EmptyScreen } from 'uiToolkitV1/EmptyScreen';
import { useExpandableContainer, ExpandableContainerProvider } from 'uiToolkitV1/ExpandableContainerProvider';
import { TextBodyMedium, TextHeader3 } from 'uiToolkitV1/Typography';

import { LoadingOverlayComponent } from '../LoadingOverlayComponent';

const ChartContainer = ({
  chartData,
  chartTitle = 'Chart Title',
  children,
  isExpandable = true,
  chartRef,
  containerProps = {},
}) => {
  const { isExpanded = false } = useExpandableContainer();

  const downloadChartImage = useCallback(() => {
    if (chartRef.current) {
      chartRef.current.download();
    }
  }, []);

  return (
    <Box {...containerProps}>
      <ExpandableContainerProvider
        id={`${chartTitle}`}
        toggleBtnBoxProps={{ top: '17px !important', zIndex: isExpandable ? 1 : 0 }}
      >
        <Flex
          id="myChart"
          width="100%"
          height="364px"
          justify="center"
          align="center"
          borderRadius="8px"
          padding="0px 12px 0px 12px"
          backgroundColor="white"
          // mb="4px"
          position="relative"
          boxShadow="0px 0px 2px 0px rgba(0, 0, 0, 0.24)"
        >
          <Flex h="100%" w="100%" flexDirection="column" m={isExpanded ? '0px 12px' : '0px'}>
            <Flex m="14px 0px">
              <TextHeader3 bold color="text.g1" ml="6px">
                {chartTitle}
              </TextHeader3>
              <Flex m="2px 44px 0 auto">
                <Button variant="tertiary" EndIcon={Download} onClick={downloadChartImage} />
              </Flex>
            </Flex>

            {chartData?.isLoading ? (
              <Flex position="absolute" left="50%" top="50%" transform="translate(-50%, -50%)">
                <LoadingOverlayComponent />
                <TextBodyMedium>No data available to be charted</TextBodyMedium>
              </Flex>
            ) : (
              <>
                {chartData?.rowData?.length === 0 ? (
                  <EmptyScreen illustrationSrc={noDataGraphV1} heading="No data available to be charted." />
                ) : (
                  <Box h={isExpanded ? '90%' : '100%'}>
                    <div
                      className="rabbit-ds"
                      style={{
                        height: isExpanded ? '90%' : '100%',
                        marginTop: isExpanded ? '0px' : '-15px',
                      }}
                    >
                      {cloneElement(children, { ref: chartRef })}{' '}
                    </div>
                  </Box>
                )}
              </>
            )}
          </Flex>
        </Flex>
      </ExpandableContainerProvider>
    </Box>
  );
};

export default ChartContainer;
